export enum BubbleRoundingOptions {
	TOP = 'TOP',
	BOTTOM = 'BOTTOM',
	ALL = 'ALL',
	NONE = 'NONE'
}